import React__default from 'react';
import { __extends, __rest, __assign } from '../../../_virtual/_tslib.js';
import classnames from 'classnames';
import Avatar from '../../Avatar/index.js';
import times from 'lodash/times';
import StarIcon from './star.svg.js';
import styles from './styles.css.js';

var ChatHeader =
/** @class */
function (_super) {
  __extends(ChatHeader, _super);

  function ChatHeader(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {};
    _this.tick = _this.tick.bind(_this);
    return _this;
  }

  ChatHeader.prototype.componentDidMount = function () {
    this.timer = setInterval(this.tick, 2000);
  };

  ChatHeader.prototype.componentWillUnmount = function () {
    if (this.timer) {
      clearInterval(this.timer);
    }
  };

  ChatHeader.prototype.tick = function () {
    this.setState(function (prevState) {
      return {
        alertNewMessage: !prevState.alertNewMessage
      };
    });
  };

  ChatHeader.prototype.render = function () {
    var _a;

    var _b = this.props,
        recipients = _b.recipients,
        unread = _b.unread,
        className = _b.className,
        minimized = _b.minimized,
        online = _b.online,
        ctaIcon = _b.ctaIcon,
        ctaText = _b.ctaText,
        onCtaClick = _b.onCtaClick,
        rest = __rest(_b, ["recipients", "unread", "className", "minimized", "online", "ctaIcon", "ctaText", "onCtaClick"]);

    var CtaIcon = this.props.ctaIcon; // for lead conversations, support agents may not always leave the conversation
    // filter out Curated Support to hide display name in the chat widget button and header

    var nonSupportRecipients = recipients.filter(function (recipient) {
      return recipient.type !== 'SUPPORT';
    }); // "Tom", "Dick" and "Harry"

    var recipientNames = nonSupportRecipients.map(function (recipient) {
      return recipient.displayName;
    });
    var recipientsLabel = [recipientNames.slice(0, -1).join(', '), recipientNames.slice(-1)[0]].join(recipientNames.length < 2 ? '' : ' and ');
    var primaryRecipient = nonSupportRecipients[0];
    return React__default.createElement("div", __assign({
      className: classnames(styles.header, className, (_a = {}, _a[styles.minimized] = minimized, _a))
    }, rest), React__default.createElement("div", {
      className: styles.avatarAndPresence
    }, React__default.createElement(Avatar, {
      sender: primaryRecipient,
      size: 48,
      shape: "circle",
      className: styles.avatar
    }), online && React__default.createElement("span", {
      className: styles.presenceBadge
    })), React__default.createElement("div", {
      className: styles.labels
    }, React__default.createElement("div", {
      className: styles.title
    }, unread && this.state.alertNewMessage ? 'New message' : recipientsLabel), primaryRecipient && primaryRecipient.expertRating !== undefined && React__default.createElement("div", {
      className: styles.starsRating
    }, React__default.createElement("div", {
      className: styles.stars
    }, times(Math.round(primaryRecipient.expertRating)).map(function (i) {
      return React__default.createElement(StarIcon, {
        className: styles.star,
        key: i
      });
    })))), (ctaIcon || ctaText) && React__default.createElement("div", {
      className: styles.cta,
      onClick: function onClick(e) {
        e.stopPropagation();
        onCtaClick && onCtaClick(e);
      }
    }, CtaIcon && React__default.createElement(CtaIcon, {
      className: styles.ctaIcon
    }), ctaText && React__default.createElement("span", {
      className: styles.ctaText
    }, ctaText)));
  };

  return ChatHeader;
}(React__default.Component);

export default ChatHeader;
//# sourceMappingURL=index.js.map
